import get from "lodash/get";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import Button from "@material-ui/core/Button";
import { instance } from "../../../../Actions/AxiosInstance";
import address from "../../../../Assets/Images/address.svg";
import addressEmployee from "../../../../Assets/Images/address.svg";
import FloatingActionButtons from "../../../../Component/FloatingActionButton/FloatingActionButtons";
import createstore from "../../../../store";
import EmpAddressForm from "./EmpAddressForm";
import If from "../../../../Component/Common/If";
import CreateComp from "../create";
import { NoRecordFound } from "./NoRecordFound";

class EmpAddress extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      list: {
        addresstypeid: "",
      },
      addresstypeid: "",
      errors: {},
      helperText: {},
      country: [],
      AllAddress: [],
      flag: 4,
      successFlag: false,
      ProfileBasicInfo: {},
      hideButton: false,
      colleagueid: null,
      dataReceived: false,
      masterprofileid:null,
    };
  }

  componentDidMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;
    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
    ? colleagueid && colleagueid != employeeid
      ? masterprofileid != 9
        ? (hideButton = true)
        : (hideButton = false)
      : (hideButton = false)
    : masterprofileid != 9 ? (hideButton = true) : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
        masterprofileid
      },
      () => {
        this.GetProfileBasicInfo();
        this.GetAllAddress();
      },
    );
  }

  GetProfileBasicInfo() {
    const URL = "/employee/empaboutme";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let ProfileBasicInfo = [];
        result.data.result.length != 0
          ? (ProfileBasicInfo = result.data.result[0])
          : (ProfileBasicInfo = []);
        this.setState({ ProfileBasicInfo });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  SetFlag(value, addressid) {
    const { list } = this.state;
    const flag = value;
    list.addresstypeid = addressid;
    this.setState({ flag, list, AddressDetails: {} }, () => {
      if (value != 1) this.GetAllAddress();
    });
  }

  GetAddr(value, addressid, data, success, e) {
    const { list } = this.state;
    const flag = value;
    list.addresstypeid = addressid;
    const presentAddr = data;
    this.setState(
      {
        flag,
        list,
        presentAddr,
        successFlag: success,
      },
      () => {
        this.GetAllAddress();
        this.props.UpdateStrength(true);
      },
    );
  }

  BackLink(data) {
    this.state.AllAddress.length == 0
      ? this.setState({ flag: 0 })
      : this.setState({ flag: 4 });
  }

  GetAllAddress() {
    const URL = "employee/getempalladdress";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        const AllAddress = [];
        if (result.data.result.length == 0) {
          this.setState({ flag: 0, dataReceived: true });
        } else {
          this.setState({
            AllAddress: result.data.result,
            dataReceived: true,
            flag: 4,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  UpdatePresentAddress(value, addressid) {
    const info = {
      addressline1: this.state.presentAddr.addressline1,
      addressline2: this.state.presentAddr.addressline2
        ? this.state.presentAddr.addressline2
        : undefined,
      pincode: this.state.presentAddr.pincode
        ? this.state.presentAddr.pincode
        : undefined,
      countryid: this.state.presentAddr.countryid,
      stateid: this.state.presentAddr.stateid,
      cityid: this.state.presentAddr.cityid,
      addresstypeid: addressid,
    };
    if (!createstore.getState().AuthenticationAction.IsFulfilled) {
      Object.assign(info, {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.colleagueid || this.state.employeeid,
      });
    }
    instance
      .post("employee/insertupdateempaddress", info)
      .then((result) => {
        this.setState({ flag: value });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPerticularAddress(value, data, e) {
    const AddressDetails = data;
    const flag = value;
    this.setState({ AddressDetails, flag });
  }

  DeleteEmpAddress = (item) => {
    const employeeid = this.props.colleagueid || this.state.employeeid;
    const data = {
      employeeid : employeeid,
    }
    const URL = `/employee/deleteempaddress/${item.employeeaddressid}/${item.addressid}`;
    instance
      .delete(URL, this.state.masterprofileid && this.state.masterprofileid == 9 && {data})
      .then((resp) => {
        this.GetAllAddress();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  Deleteconfirmation = (item) => {
    this.props.enqueueSnackbar(`Are you sure you want to delete?`, {
      variant: "warning",
      action: [
        <Button
          variant="outlined"
          color="inherit"
          className="margin-right-16"
          size="small"
          onClick={() => this.DeleteEmpAddress(item)}
        >
          Delete
        </Button>,
        <Button color="inherit" size="small">
          Cancel
        </Button>,
      ],
    });
  };

  render() {
    const { activeIndex, dataReceived, AllAddress, hideButton } = this.state;
    let model;
    const { classes } = this.props;
    const address = AllAddress.find((add) => add.addresstypeid == 2);
    let sameaddress = false;
    if (address && address.addresstypeid == 2) {
      sameaddress = true;
    }
    const { flag } = this.state;
    if (flag === 0) {
      model = (
        <div>
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {!hideButton ? (
                <CreateComp
                  text="Tell us where you live"
                  heading="Address details"
                  onCreate={this.SetFlag.bind(this, 1, 1)}
                  imageSrc={addressEmployee}
                />
              ) : (
                <NoRecordFound />
              )}
            </Grid>
          </Grid>
        </div>
      );
    }

    if (flag == 1) {
      model = (
        <div>
          <EmpAddressForm
            GetAddr={this.GetAddr.bind(this)}
            BackLink={this.BackLink.bind(this)}
            addresstypeid={this.state.list.addresstypeid}
            data={this.state.AddressDetails}
            AllAddress={this.state.AllAddress}
            {...this.props}
            colleagueid={this.state.colleagueid}
          />
        </div>
      );
    }

    if (flag === 2 && !sameaddress) {
      model = (
        <div>
          <p className="input-form-label address-label">
            {" "}
            <FormattedMessage
              id="LbAddressSavedFirstTime__"
              defaultMessage="Is your present & permanent address is same?"
            />{" "}
          </p>
          <div
            className="form-btn form-control margin-right-20"
            onClick={this.UpdatePresentAddress.bind(this, 3, 2)}
          >
            <FormattedMessage id="Btyes" defaultMessage="Yes" />
          </div>
          <div
            className="form-btn form-control"
            onClick={this.SetFlag.bind(this, 4, 2)}
          >
            <FormattedMessage id="Btno" defaultMessage="No" />
          </div>
        </div>
      );
    }

    if (flag === 3) {
      model = (
        <div>
          <p className="input-form-label address-label">
            {" "}
            <FormattedMessage
              id="Lbreceivedyouraddress"
              defaultMessage="Great, we added your address details"
            />{" "}
          </p>
          <p className="input-form-label address-label">
            {" "}
            <FormattedMessage
              id="Lbanyoheraddress"
              defaultMessage="Do you have any other address?"
            />{" "}
          </p>
          <div
            className="form-btn form-control margin-right-20"
            onClick={this.SetFlag.bind(this, 1, 5)}
          >
            <FormattedMessage id="Btyes" defaultMessage="Yes" />
          </div>
          <div
            className="form-btn form-control"
            onClick={this.SetFlag.bind(this, 4, 1)}
          >
            <FormattedMessage id="Btno" defaultMessage="No" />
          </div>
        </div>
      );
    }

    if (flag === 4) {
      model = (
        <div className="profile-data-view-page">
          {this.state.successFlag ? (
            <p className="input-form-label address-label">
              {" "}
              <FormattedMessage
                id="Lbaddressreceived"
                defaultMessage="Congratulations, you have added your address details successfully."
              />{" "}
            </p>
          ) : (
            ""
          )}
          {this.state.AllAddress.length > 0 ? (
            <div className="width100">
              <div>
                {this.state.AllAddress.map((address) => (
                  <div className="padding-bottom-20 position-rel">
                    <div className="inlineClass address-icon">
                      {/* <img src={Home} alt="icon" height="15" /> */}
                    </div>
                    <p className="address-data1 inlineClass">
                      {address.addressline1},
                      {address.addressline2 ? address.addressline2 : ""}
                      <br />
                      {address.countryname}, {address.statename},{" "}
                      {address.cityname} - {address.pincode}
                      <br />
                      {address.addresstypeid == 1 ? (
                        <Chip
                          label="Present Address"
                          className={classes.chip}
                        />
                      ) : (
                        ""
                      )}
                      {address.addresstypeid == 2 ? (
                        <Chip
                          label="Permanent Address"
                          className={classes.chip}
                        />
                      ) : (
                        ""
                      )}
                      {address.addresstypeid != 1
                      && address.addresstypeid != 2 ? (
                        <Chip label="Other" className={classes.chip} />
                      ) : (
                        ""
                      )}
                    </p>
                    <If condition={!hideButton}>
                      <div>
                        <svg
                          className={"address-edit cursour-pointer"}
                          onClick={this.GetPerticularAddress.bind(
                            this,
                            1,
                            address,
                          )}
                          width="24"
                          style={{ marginRight: 40 }}
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                        </svg>
                        <svg
                          className={"address-edit cursour-pointer"}
                          onClick={() => this.Deleteconfirmation(address)}
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                          <path fill="none" d="M0 0h24v24H0V0z" />
                        </svg>
                      </div>
                    </If>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div>
              <FormattedMessage
                id="LbNoRecordFound"
                defaultMessage="No Record Found"
              />
            </div>
          )}
          {!hideButton && (
            <div
              className={
                this.state.hideButton ? "hide-button" : "add-more-button"
              }
              onClick={this.SetFlag.bind(this, 1, 1)}
            >
              <Button variant="contained" color="primary" className="no-shadow">
                Add More
              </Button>
            </div>
          )}
        </div>
      );
    }

    return (
      <If condition={dataReceived}>
        <div>{model}</div>
      </If>
    );
  }
}

const VerticalTabs = withStyles((theme) => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles((theme) => ({
  selected: {
    color: "tom66y4ato",
    borderBottom: "2px solid tomato",
  },
}))(Tab);

export default withSnackbar(EmpAddress);
